<template>
  <v-app>
    <v-navigation-drawer v-model="isFilterDrawerOpen" app temporary right>
      <v-list dense>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon>mdi-magnify</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-text-field label="Search" v-model="textFilter"></v-text-field>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list dense subheader>
        <v-subheader>Brands</v-subheader>
        <v-list-item-group v-model="brandFilter" multiple>
          <template v-for="brand in brands">
            <v-list-item
              :key="`brand-${brand.id}`"
              :value="brand.id"
              active-class="deep-orange--text text--accent-4"
            >
              <template v-slot:default="{ active, toggle }">
                <v-list-item-action>
                  <v-checkbox
                    :input-value="active"
                    :true-value="brand.id"
                    color="deep-orange accent-4"
                    @click="toggle"
                  ></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title v-text="brand.name"></v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-toolbar-title>Binder Registration</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
        icon
        @click.stop="isFilterDrawerOpen = !isFilterDrawerOpen"
        v-if="library"
      >
        <v-icon>mdi-filter-variant</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-footer app style="height: 50px;" color="transparent">
      <v-fab-transition>
        <v-btn
          color="pink"
          absolute
          top
          right
          fab
          dark
          v-show="needsSaved"
          @click.stop="saveCustomer"
        >
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-footer>
  </v-app>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapMutations } = createNamespacedHelpers("customer/");
export default {
  name: "App",
  data() {
    return {
      brands: [
        { id: 1, name: "Silica" },
        { id: 2, name: "Sina Pearson" },
        { id: 3, name: "WSG" },
        { id: 4, name: "Momentum" }
      ]
    };
  },
  computed: {
    ...mapState(["needsSaved", "library"]),
    isFilterDrawerOpen: {
      get() {
        return this.$store.getters["filters/isFilterDrawerOpen"];
      },
      set(v) {
        return this.$store.commit("filters/toggleFilterNavigationDrawer", v);
      }
    },
    brandFilter: {
      get() {
        return this.$store.getters["filters/brandFilter"];
      },
      set(v) {
        return this.$store.commit("filters/setBrandFilter", v);
      }
    },
    textFilter: {
      get() {
        return this.$store.getters["filters/textFilter"];
      },
      set(v) {
        return this.$store.commit("filters/setTextFilter", v);
      }
    }
  },
  methods: {
    ...mapMutations(["clearNeedsSaved"]),
    saveCustomer() {
      this.clearNeedsSaved();
    }
  }
};
</script>
